import React from 'react';
import { motion } from 'framer-motion';
import { FiBookOpen, FiDatabase, FiServer } from 'react-icons/fi';

const Learning = () => {
  const learningItems = [
    {
      icon: <FiBookOpen className="w-8 h-8" />,
      title: "DSA in Python",
      description: "Mastering algorithms and data structures",
      progress: 65
    },
    {
      icon: <FiDatabase className="w-8 h-8" />,
      title: "SQL and MongoDB",
      description: "Advanced database operations and optimization",
      progress: 70
    },
    {
      icon: <FiServer className="w-8 h-8" />,
      title: "Flask for Backend",
      description: "Building scalable web applications",
      progress: 55
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Currently Learning
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Continuous learning is key to staying ahead in technology
          </p>
        </motion.div>

        {/* Fixed container for equal card sizes */}
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {learningItems.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full flex flex-col"
            >
              <div className="text-primary mb-4">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2 min-h-[3rem] flex items-start">
                {item.title}
              </h3>
              <p className="text-gray-600 mb-4 flex-grow">
                {item.description}
              </p>
              
              <div className="mt-auto">
                <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: `${item.progress}%` }}
                    transition={{ duration: 1, delay: index * 0.2 }}
                    viewport={{ once: true }}
                    className="bg-gradient-to-r from-primary to-secondary h-2 rounded-full"
                  />
                </div>
                <div className="text-right text-sm text-gray-500">
                  {item.progress}% Progress
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Learning;
